import { useEffect, useState } from 'react';
import firebase, { db } from '../firebase';
import { DateTime } from 'luxon';
import {
  firebaseCollections as collections,
  itemStatuses,
  rentalStatuses,
} from '../constants';
import { useData } from 'utils/hooks';
import { getDelta } from '../helpers';

const useReturnRental = (rental, items, returned) => {
  const { user } = useData();
  const [isStarted, setStart] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [error, setError] = useState(null);
  let rental_id = rental?.id;
  const set = () => {
    setStart(true);
  };

  useEffect(() => {
    if (isStarted) {
      setLoading(true);
      let batch = db.batch();
      const updatedItems = rental?.items.map((item) => {
        if (returned[item.id]) {
          return { ...item, returnedStatus: returned[item.id] };
        }
        return item;
      });

      let rentalRef = db.collection(collections.rentals).doc(rental_id);
      let returnObj = {
        rentalReturnedBy: {
          uid: user?.uid ?? '',
          name: user?.name ?? '',
          email: user?.email ?? '',
        },
      };

      const shouldClose =
        updatedItems.filter(
          (item) => item?.returnedStatus !== itemStatuses.returned
        ).length === 0;
      if (shouldClose) {
        returnObj = {
          ...returnObj,
          status: rentalStatuses.closed,
          closedDate: firebase.firestore.Timestamp.now(),
          rentalClosedBy: {
            uid: user?.uid ?? '',
            name: user?.name ?? '',
            email: user?.email ?? '',
          },
        };
      }
      batch.update(rentalRef, returnObj);
      let nowDate = DateTime.utc();
      items
        .filter((i) => Object.keys(returned).includes(i.id))
        .forEach((item) => {
          let timeDelta = '';
          try {
            timeDelta = getDelta(nowDate, item?.dueDateOriginal);
          } catch (e) {
            console.log(e);
          }
          let itemRef = db
            .collection(collections.rentals)
            .doc(rental_id)
            .collection(collections.items)
            .doc(item?.id);
          if (returned[item.id] !== '') {
            batch.update(itemRef, {
              returnedStatus: returned[item.id],
            });
            if (returned[item.id] === itemStatuses.returned) {
              batch.update(itemRef, {
                returnDate: nowDate.toString(),
                returnedTimeDifference: timeDelta,
                returnStore: returned.returnStore,
              });
            }
          }
        });

      batch
        .commit()
        .then(() => {
          setFetched(true);
          setLoading(false);
        })
        .catch((e) => {
          setError(e);
          setLoading(false);
        });
    }
  }, [isStarted]);
  return { loading, error, saveReturn: set, fetched };
};

export default useReturnRental;
